<div class="plans">
  <app-header title="Plans" [progressvalue]="100" routeName="carrier"></app-header>
  <div class="wb-coverage-wrapper wb-full-height">
    <div class="wb-wrapper">
      <div class="wb-coverage-wrapper wb-full-height">
        <section class="wb-coverage-content coverage-content-hidden wb-coverage-content-padding-btm">
          <div class="cell">
            <ul class="sub-flow-nav">
              <li [ngClass]="allPlans==true ?'active-item':''"><span (click)="showAllPlans()"><a>All Plans</a></span>
              </li>
              <li [ngClass]="allPackagePlans==true ?'active-item':''"><span (click)="showAllPackagePlans()"><a>Plans by
                    Package</a></span></li>
            </ul>
          </div>
          <h3 class="text-center" [ngClass]="allPlans!=true ?'inactive':''"> This option lets you select plans from a
            list of all eligible plans </h3>
          <h3 class="text-center" [ngClass]="allPackagePlans!=true ?'inactive':''"> This option lets you select plans
            only from one carrier package. </h3>
          <div *ngIf="allPlans">
            <div class="package-carousel">
              <div class="carousel-cell carrier-package all-plans">
                <div class="card-content">
                  <div class="content-wrap displaydiv" *ngIf="webPackageDisplayed.length > 0">
                    <div>
                      <div class="grid-x plan-selected">
                        <div class="cell small-12 all-plan-selected">
                          <p>
                            <span class="active-item"
                              *ngIf=" getTotalPlansSelected() > 0 && retainAllPlans">{{totalPlansSelected}}</span>
                            {{((totalPlansSelected > 1) && retainAllPlans) ?"Plans":"Plan"}} Selected
                          </p>
                        </div>
                      </div>
                      <div *ngFor="let benefitType of benefitTypes">
                        <div class="hmo-plans"
                          *ngFor="let network of allPlansDisplayed | NetworkType: benefitType; let networkIndex=index">
                          <div *ngIf="network.ShowNetworkInAllPlans">
                            <div class="grid-x coverage-item header"
                              [ngClass]="{'included': network?.IsSelectBoxActive && retainAllPlans}">
                              <div class="cell shrink align-self-middle" (click)="selectOrUnselectNetwork(network);">
                                <div class="include-coverage">
                                  <i class="material-icons">check_circle</i>
                                </div>
                              </div>
                              <div class="cell auto align-self-middle">
                                <h3>{{network.NetworkName}} </h3>
                              </div>
                            </div>
                            <div class="grid-x coverage-item "
                              [ngClass]="(plan?.IsSelectBoxActive==true && retainAllPlans)?'included':' '"
                              *ngFor="let plan of network.Plans;let planIndex=index">
                              <div class="cell shrink align-self-middle" *ngIf="plan?.PlanRates?.length>0">
                                <div class="include-coverage">
                                  <i class="material-icons"
                                    (click)="selectOrUnselectPlans(plan,network)">check_circle</i>
                                </div>
                              </div>
                              <div class="cell auto align-self-middle" *ngIf="plan?.PlanRates?.length>0">
                                <h3>{{plan.PlanName}} </h3>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="allPackagePlans">
            <div class="package-carousel">
              <div class="carousel-cell carrier-package"
                *ngFor="let wabPackage of webPackageDisplayed | PackageSort; let packageIndex = index">
                <div class="card-content" *ngIf="wabPackage.Networks.length>0">
                  <div class="data-wrap">
                    <div class="grid-x">
                      <div class="cell auto align-self-middle">
                        <h3>{{wabPackage.PackageName}} </h3>
                      </div>
                      <div class="cell shrink align-self-middle">
                        <div class="include-carrier" [ngClass]="{'url': !(!wabPackage?.BundlePlanId ),
                                'included': wabPackage?.IsSelectBoxActive && !retainAllPlans}">
                          <i class="material-icons" (click)="selectOrUnselectPackage(wabPackage)">check_circle</i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="content-wrap"
                    [style.display]="wabPackage?.IsSelectBoxActive && !retainAllPlans ? 'block':'none'">
                    <div class="grid-x plan-selected">
                      <div class="cell small-12">
                        <p>
                          <span class="active-item"
                            *ngIf="wabPackage?.IsSelectBoxActive && wabPackage.PlanSelected > 0 && !retainAllPlans">{{wabPackage.PlanSelected}}</span>
                          {{((wabPackage.PlanSelected > 1) && wabPackage?.IsSelectBoxActive && !retainAllPlans)
                          ?"Plans":"Plan"}} Selected
                        </p>
                      </div>
                    </div>
                    <div class="hmo-plans" *ngFor="let network of wabPackage.Networks; let networkIndex=index">
                      <div class="grid-x coverage-item header"
                        [ngClass]="{'included': network?.IsSelectBoxActive && !retainAllPlans}">
                        <div class="cell shrink align-self-middle"
                          (click)="selectOrUnselectNetwork(network,wabPackage, false);">
                          <div class="include-coverage">
                            <i class="material-icons">check_circle</i>
                          </div>
                        </div>
                        <div class="cell auto align-self-middle">
                          <h3> {{network.NetworkName}} </h3>
                        </div>
                      </div>
                      <div class="grid-x coverage-item"
                        [ngClass]="(plan?.IsSelectBoxActive==true && !retainAllPlans)?'included':' '"
                        *ngFor="let plan of network.Plans;let planIndex=index">
                        <div class="cell shrink align-self-middle" *ngIf="plan?.PlanRates?.length>0">
                          <div class="include-coverage">
                            <i class="material-icons"
                              (click)="selectOrUnselectPlans(plan,network,wabPackage, false)">check_circle</i>
                          </div>
                        </div>
                        <div class="cell auto align-self-middle" *ngIf="plan?.PlanRates?.length>0">
                          <h3>{{plan.PlanName}} </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
  <footer class="wb-coverage-footer">
    <div>
      <button class="wb-button mdl-button mdl-js-button set-contribution-button" [disabled]="isPlanSelected"
        (click)="openContributionDialoge()">Set Contribution</button>
      <button class="wb-button mdl-button mdl-js-button" [disabled]="isPlanSelected" [attr.data-qaauto]="'Generate-Button'" (click)=openGenerateDialog()>
        Generate </button>
    </div>
  </footer>
</div>